<template>
  <div>
    <ModalComponent
      modalName="qrCodeModal"
      class="qrCodeModal"
      @modal-closed="onModalClosed"
    >
      <div
        :style="
          !timeIsUp && !diyaFirstStep && !isMobile
            ? 'min-height: 326px'
            : 'min-height: auto'
        "
      >
        <div v-show="diyaFirstStep">
          <div class="qrCodeModal__title">{{ diyaRenderData.label }}</div>
          <BaseCheckbox
            class="vin-checker__checkbox"
            :validate="true"
            :isVariant="3"
            :value="userAgreement"
            :custom-handler="userAgreementHandler"
          >
            <p class="checkBox-label" v-html="diyaRenderData.urlText" />
            <p class="checkBox-disclaimer" v-html="diyaRenderData.disclaimer" />
          </BaseCheckbox>

          <BaseButton
            class="agreeButton"
            :disabled="!userAgreement"
            :isLoading="isLoading"
            @click="getVinFromDiya"
          >
            {{ diyaRenderData.buttonLabel }}
          </BaseButton>
        </div>
        <div v-show="diyaSecondStep" class="secondStep">
          <div :class="showLoader ? 'diyaLoader show' : 'diyaLoader hide'">
            <img
              class="diyaLoader__img"
              src="./../assets/img/icons/LoaderDiya.gif"
              alt="LoaderDiya"
            >
            <div class="diyaLoader__text">Зачекайте, завантажуємо дані</div>
          </div>
          <div
            :class="
              showLoader
                ? 'qrCodeModal__content hide'
                : 'qrCodeModal__content show'
            "
            :style="
              !timeIsUp && showTimer && !isMobile
                ? 'min-height: 326px'
                : 'min-height: auto'
            "
          >
            <div class="qrCodeModal__title-main">
              {{ diyaRenderData.timerLabel }}
            </div>
            <div v-show="!isMobile" class="qrCodeModal__title">
              {{ diyaRenderData.scanCodeLabel }}
            </div>
            <div v-if="!timeIsUp && showTimer" class="qrCodeModal__timer">
              Код діятиме ще
              <flip-countdown
                :showDays="false"
                :showHours="false"
                :twoDigits="true"
                :deadline="endTime"
                @timeElapsed="timeElapsedHandler"
              />
              хв
            </div>
            <BaseButton
              v-else class="updateQrCode"
              @click="updateQrCode"
            >
              {{ diyaRenderData.renewQrLabel }}
            </BaseButton>
            <div v-if="!timeIsUp" class="qrCodeModal__img">
              <img
                v-if="!isMobile" :src="diyaData.qrSrc"
                alt="QRcodeIMAGE"
              >
              <a
                v-else :href="diyaData.deeplink"
                :target="computedTarget" class="diyaButton"
              >
                <img
                  src="./../assets/img/icons/logo_diia_white.svg"
                  alt="logo_diia_white"
                >
                {{ diyaRenderData.openPopupLabel }}
              </a>
            </div>
          </div>
        </div>
        <div v-show="getVinFromDiyaError" class="diyaError">
          <div class="qrCodeModal__title">
            {{ diyaRenderData.exceptionLabel }}
          </div>
          <p class="exceptionText__error">
            <img
              src="./../assets/img/icons/attentionIcon.svg"
              alt="attentionIcon"
            >
            {{ diyaRenderData.exceptionText }}
          </p>
          <BaseButton :isLoading="isLoading" @click="resetStep">
            {{ diyaRenderData.closeButtonLabel }}
          </BaseButton>
        </div>
      </div>
    </ModalComponent>
    <div class="vin-checker">
      <p class="vin-checker__title">{{ title }}</p>
      <form class="vin-checker__form" @submit.prevent="submitForm">
        <BaseInput
          :value="code"
          class="vin-checker__input"
          :placeholder="placeholderText"
          mask="vin"
          :disabled="isLoading"
          fieldType="diya"
          :fieldTypeAction="showDiyaModal"
          @input="code = $event.toUpperCase()"
        />
        <BaseButton
          :disabled="!code || code.length !== 17"
          :isLoading="isLoading"
          class="vin-checker__button"
          :class="{
            'vin-checker__button--not-allowed': !code || code.length !== 17,
          }"
          tagType="submit"
        >
          {{ buttonText }}
        </BaseButton>
        <div
          v-if="!isMd" class="diyaButton"
          @click="showDiyaModal($event)"
        >
          <img
            src="./../assets/img/icons/logo_diia_white.svg"
            alt="logo_diia_white"
          >
          {{ diyaRenderData.openPopupLabel }}
        </div>
      </form>
      <CollapseTransition>
        <div v-if="errText" key="errWrapper">
          <NotificationBanner :msg="errText" class="vin-checker__error" />
        </div>
      </CollapseTransition>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import { get } from 'lodash'
  import NotificationBanner from '@/components/NotificationBanner'
  import { CollapseTransition } from 'vue2-transitions'
  import $axios from '@/plugins/axios'
  import axios from 'axios'
  import router from '@/router'
  import ModalComponent from '@/components/base/ModalComponent.vue'
  import FlipCountdown from 'vue2-flip-countdown'
  import moment from 'moment'
  import { DEFAULT_LANG, isMd } from '@/helpers/constant'

  export default {
    name: 'VinChecker',

    components: {
      ModalComponent,
      NotificationBanner,
      CollapseTransition,
      FlipCountdown
    },

    data () {
      return {
        isLoading: false,
        errText: '',
        code: '',
        diyaData: {
          qrSrc: ''
        },
        abortController: null,
        diyaFirstStep: true,
        isLoadingDiyaData: false,
        diyaSecondStep: false,
        userAgreement: false,
        getVinFromDiyaError: false,
        endTime: null,
        timeIsUp: false,
        showTimer: false,
        showLoader: false,
        diyaPopupRendered: false
      }
    },

    computed: {
      ...mapState(['general', 'isMobile']),
      ...mapGetters(['isMobile']),
      mobile () {
        return !!this.isMobile
      },
      isMd () {
        return isMd
      },
      title () {
        return get(this, 'general.vin-checker.title')
      },
      buttonText () {
        return get(this, 'general.vin-checker.buttonText')
      },
      buttonDiyaText () {
        return get(this, 'general.vin-checker.buttonDiyaText')
      },
      placeholderText () {
        return get(this, 'general.vin-checker.placeholder')
      },
      diyaRenderData () {
        return get(this, 'general.diya')
      },
      computedTarget () {
        const isInIframe = window.self !== window.top
        const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) || window.innerWidth < 768
        return isInIframe && isMobile ? '_blank' : '_self'
      }
    },

    activated () {
      this.reset()
    },

    methods: {
      ...mapActions(['submitVinCode']),

      createCancelToken () {
        this.cancelToken = axios.CancelToken.source()
      },

      cancelFetchVinFromDiya () {
        if (this.cancelToken) {
          this.cancelToken.cancel('Operation canceled by the user.')
        }
      },

      async fetchVinFromDiya (requestId) {
        this.createCancelToken()

        try {
          const { data } = await $axios.get(
            `/get-diya-meta-data?requestId=${requestId}`,
            {
              cancelToken: this.cancelToken.token
            }
          )

          if (data) {
            this.$store.commit('setDiyaData', data.data)
            this.code = data.data.vin
            this.$modal.hide('qrCodeModal')
            this.isLoadingDiyaData = false
            this.submitForm(true)
          }
          return data.data
        } catch (err) {
          if (axios.isCancel(err)) {
            console.log('Fetch canceled', err.message)
          } else {
            this.getVinFromDiyaError = true
            this.showLoader = false
            this.diyaSecondStep = false
            this.diyaFirstStep = false
            this.showTimer = false
            console.error('FAILED: fetchVinFromDiya')
            console.error(err)
            router.push('/')
          }
        } finally {
          this.isLoadingDiyaData = false
          this.cancelToken = null
        }
      },

      async showDiyaModal (event) {
        const openModal = () => {
          this.$modal.show('qrCodeModal', {})
          this.timeIsUp = false
          this.diyaPopupRendered = true

          if (window.self === window.top) return

          this.$nextTick(() => {
            const sendPopupPosition = (attempt = 0) => {
              const modal = document.querySelector('.vm--modal[aria-modal="true"]')
              if (!modal) {
                if (attempt < 60) {
                  window.requestAnimationFrame(() => {
                    sendPopupPosition(attempt + 1)
                  })
                }
                return
              }

              const rect = modal.getBoundingClientRect()

              if ((rect.top <= 0 || rect.height <= 0) && attempt < 60) {
                window.requestAnimationFrame(() => {
                  sendPopupPosition(attempt + 1)
                })
                return
              }

              if (rect.top <= 0 || rect.height <= 0) return

              window.parent.postMessage({
                type: 'maintenance-map:diya-popup-open',
                popupTop: rect.top + window.scrollY,
                popupHeight: rect.height,
                delay: 0
              }, '*')
            }

            window.requestAnimationFrame(() => sendPopupPosition())
          })
        }

        if (window.self !== window.top) {
          const delay = this.diyaPopupRendered ? 0 : 500
          setTimeout(openModal, delay)
        } else {
          openModal()
        }
      },
      async getVinFromDiya () {
        this.diyaFirstStep = false
        this.isLoadingDiyaData = true
        this.showLoader = true
        this.diyaSecondStep = true

        const isInIframe = window.self !== window.top
        const newWindow = null

        if (isInIframe && window.innerWidth < 768) {
        // Открываем пустое окно сразу — браузер разрешит
        // newWindow = window.open("", "_blank");
        }

        try {
          const { data } = await $axios.get('/get-diya-request')

          if (data) {
            this.endTime = moment()
              .add(181, 'seconds')
              .format('YYYY-MM-DD HH:mm:ss')
            this.showTimer = true
            this.diyaData = data
            this.isLoadingDiyaData = false
            this.timeIsUp = false

            setTimeout(() => {
              this.showLoader = false
            }, 1000)

            if (newWindow) {
            // Задаём URL уже после получения данных
            // newWindow.location.href = data.deeplink;
            }

            await this.fetchVinFromDiya(data.requestId)
          }
          return data.data
        } catch (err) {
          if (newWindow) {
            newWindow.close()
          }
          this.getVinFromDiyaError = true
          this.isLoadingDiyaData = false
          console.error('FAILED: fetchVinFromDiyaData')
          console.error(err)
          router.push({ name: 'not-found' })
        }
      },
      async submitForm (fromDiya = false) {
        if (!fromDiya) {
          this.$store.commit('setDiyaData', {
            brand: '',
            firstName: '',
            lastName: '',
            licensePlate: '',
            model: '',
            vin: ''
          })
        }
        try {
          this.$store.commit('SET_VIN_SEARCH_DATA', {})
          this.isLoading = true
          this.errText = ''
          const res = await this.submitVinCode({
            form: { vin: this.code }
          })
          // data for next pages
          this.$store.commit('SET_VIN_SEARCH_DATA', {
            vin: this.code,
            open_campaigns: res.modelOpenCampaignsSpec,
            modelOpenCampaignsMessage: res.modelOpenCampaignsMessage
          })
          if (res.modelParams && res.modelParams.carModelId) {
            const lang = this.$store.state.currentLang
            const queryLang = lang !== DEFAULT_LANG ? { lang } : {}

            this.$router.push({
              name: 'tech-map',
              params: {
                model: res.modelParams.carModelId,
                year: res.modelParams.generationId,
                modification: res.modelParams.modificationId
              },
              query: {
                queryLang
              }
            })
          } else {
            this.errText = res.modelNotFoundMessage
          }
        } catch (err) {
          if (err.response.data) {
            this.errText = err.response.data.vin
          }
        } finally {
          this.isLoading = false
        }
      },
      reset () {
        this.code = ''
        this.errText = ''
        this.$store.commit('SET_VIN_SEARCH_DATA', {})
      },
      onModalClosed () {
        this.timeIsUp = false
        this.resetStep()
        this.isLoadingDiyaData = false
        this.cancelFetchVinFromDiya()
      },
      userAgreementHandler () {
        this.userAgreement = !this.userAgreement
      },
      resetStep () {
        this.diyaFirstStep = true
        this.diyaSecondStep = false
        this.isLoadingDiyaData = false
        this.getVinFromDiyaError = false
        this.userAgreement = false
        this.showTimer = false
      },
      updateQrCode () {
        this.diyaSecondStep = false
        this.timeIsUp = false
        this.getVinFromDiya()
      },
      timeElapsedHandler () {
        this.timeIsUp = true
        this.cancelFetchVinFromDiya()
      }
    }
  }
</script>

<style lang="scss">
.diyaButton {
  background-color: #000;
  color: $c-white;
  padding: 0 24px;
  height: 48px;
  white-space: nowrap;
  border-radius: 3em;
  margin-left: 8px;
  display: flex;
  align-items: center;
  position: relative;
  font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
  font-size: 15px;
  max-width: 250px;

  @include tablet {
    padding: 0 24px;
  }

  @include mobile {
    margin-top: 8px;
    margin-left: 0;
    width: 100%;
    max-width: 100%;
    justify-content: center;
  }

  img {
    //position: absolute;
    //top: calc(50% - 14px);
    //left: 24px;
    width: 32px !important;
    height: 32px !important;
    margin-right: 8px;
  }

  &:hover {
    cursor: pointer;
  }
}

.updateQrCode {
  display: block;
  margin: 0 auto;

  @include mobile {
    width: 100%;
  }
}

.flip-clock {
  margin: 0 2px;
}

.flip-clock__slot {
  display: none !important;
}

.flip-card {
  padding-bottom: 0 !important;
}

.flip-card__bottom {
  display: none !important;
}

.flip-card__back {
  display: none !important;
}

.flip-card__back-bottom {
  display: none !important;
}

.flip-card__top {
  background: transparent !important;
  color: #74797d !important;
  padding: 0 !important;
  width: auto !important;
  font-size: 13px;
}

.flip-clock__piece {
  margin: 0 !important;

  &:nth-of-type(3) {
    padding-right: 4px !important;
    margin-right: 1px !important;
    position: relative;

    &::after {
      content: ":";
      position: absolute;
      right: 0;
      top: -1px;
      font-size: 13px;
      color: #74797d;
    }
  }
}

.vin-checker {
  overflow: hidden;

  &__title {
    margin-bottom: 20px;
    font-size: 14px;
    color: $c-black;
    text-align: center;

    @include mobile {
      font-size: 12px;
    }
  }

  &__form {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 12px;

    @include mobile {
      flex-direction: column;
      align-items: center;
      margin-bottom: 28px;

      button {
        width: 100%;
        max-width: 100%;
        margin-left: 0;
      }
    }
  }

  &__input {
    //width: 600px;

    @include mobile {
      width: 100%;
      //margin-bottom: 10px;
    }

    &.diya {
      .input-wrapper {
        padding-bottom: 20px;
        max-width: 100%;
        min-width: 314px;

        @include tablet {
          min-width: 282px;
        }
      }
    }
  }

  &__button {
    margin-left: 15px;

    &.minPadding {
      padding: 1em 2em;
    }

    &--not-allowed {
      pointer-events: all !important;
      cursor: not-allowed !important;
    }
  }
}

.btnTxt {
  opacity: 1;
  color: #fff;

  &.hide {
    opacity: 0;
  }
}

.loader {
  width: 17px;
  height: 17px;
  border: 3px solid #fff;
  border-bottom-color: #ff3d00;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  position: absolute;
  left: calc(50% - 8px);
  opacity: 0;

  &.show {
    opacity: 1;
  }

  &::before {
    content: "";
    width: 100%;
    height: 100%;
    background-color: #f02;
    opacity: 0.5;
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 767px) {
  .getDiyaVin {
    margin-top: 15px;
  }
}

.qrCodeModal {
  max-width: 100vw;
  width: 100%;

  .base-modal-inner {
    margin: 0;
    max-height: 100vh;
  }

  .modal {
    .vm--modal {
      left: 0 !important;
      top: 50% !important;
      transform: translateY(-50%) !important;
    }
  }

  &__timer {
    font-size: 13px;
    text-align: center;
    margin-bottom: 10px;
    color: #74797d;
    display: flex;
    align-items: center;
    justify-content: center;

    .container {
      width: auto !important;
      max-width: unset !important;
      margin: 0 2px !important;
    }

    .fakeTime {
      font-size: 13px;
      text-align: center;
      color: #74797d;
      padding-left: 2px;
      padding-right: 2px;
    }
  }

  &__title-main {
    margin-bottom: 20px;
    font-size: 28px;
    color: $c-black;
    text-align: center;

    @include mobile {
      font-size: 20px;
      line-height: 27px;
      max-width: 80%;
      margin: 0 auto;
      margin-bottom: 24px;
    }
  }

  &__title {
    font-size: 22px;
    line-height: normal;
    margin-bottom: 40px;
    text-align: center;

    @include mobile {
      font-size: 18px;
      margin-bottom: 20px;
      line-height: normal;
      padding-right: 15px;
    }
  }

  .modal__content {
    padding: 48px;
    //min-height: 326px;

    @include mobile {
      padding: 16px 24px;
    }
  }

  &__img {
    text-align: center;

    .diyaButton {
      margin: 0 auto;
      text-decoration: none;

      &:hover {
        color: #fff;
      }

      @include mobile {
        font-size: 15px;
      }
    }

    img {
      width: 150px;
      height: 150px;
    }
  }

  .checkBox-label {
    font-size: 21px;
    line-height: 28px;
    margin-bottom: 8px;

    @include mobile {
      font-size: 14px;
      line-height: normal;
      margin-bottom: 0;
    }

    a {
      font-size: 21px;
      line-height: 28px;

      @include mobile {
        font-size: 14px;
        line-height: normal;
      }
    }
  }

  .checkBox-disclaimer {
    font-size: 13px;
    color: #74797d;

    @include mobile {
      font-size: 11px;
      line-height: normal;
    }
  }

  .vin-checker__checkbox {
    .checkbox-inner {
      align-items: flex-start;

      .checkbox {
        width: 24px;
        height: 24px;
        margin-top: 3px;
      }
    }
  }

  &__content {
    min-height: 336px;

    &.hide {
      opacity: 0;
      overflow: hidden;
      height: 0;
      min-height: 0 !important;
    }

    &.show {
      opacity: 1;
      height: auto;
    }
  }
}

.diyaLoader {
  width: 614px;
  height: 326px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position: relative;
  left: 0;
  top: 0;

  @include mobile {
    width: 100%;
    //height: auto;
  }

  &__img {
    margin-bottom: 48px;

    @include mobile {
      margin-bottom: 0;
    }
  }

  &__text {
    font-size: 15px;
    color: #1e2a32;
  }

  &.show {
    opacity: 1;
  }

  &.hide {
    opacity: 0;
    z-index: -1;
    height: 0;
  }
}

.secondStep {
  //min-height: 326px;
  position: relative;
}

.diyaError {
  .exceptionText__error {
    padding: 24px;
    display: flex;
    align-items: center;
    font-size: 13px;
    background-color: rgba(238, 35, 0, 0.3);
    margin-bottom: 70px;

    img {
      margin-right: 16px;
    }
  }
}

.agreeButton {
  @include mobile {
    width: 100%;
  }
}

</style>
